'use client';

import { useLocale, useTranslations } from 'next-intl';

import { LOCALE_LABELS, switchLocale } from '../../i18n/locale-switch';
import { routing } from '../../i18n/routing';

/** Small page icon (globe) for the Clerk custom-page tab label. */
export function LanguageIcon(): React.JSX.Element {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.3"
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="6.5" />
      <path d="M1.5 8h13" />
      <path d="M8 1.5c2.2 2 2.2 11 0 13c-2.2-2-2.2-11 0-13Z" />
    </svg>
  );
}

/**
 * Language picker mounted as a "Language" page in the account menu (see
 * AccountMenu). Selecting a locale hard-navigates to it (a full reload — see
 * `switchLocale`) and persists the choice for the signed-in user.
 */
export function LanguagePanel(): React.JSX.Element {
  const locale = useLocale();
  const t = useTranslations('home');

  return (
    <div className="text-sm text-gray-900">
      <h1 className="mb-3 text-base font-semibold text-gray-900">
        {t('languageLabel')}
      </h1>
      <ul className="flex flex-col gap-1">
        {routing.locales.map((code) => (
          <li key={code}>
            <button
              type="button"
              aria-current={code === locale}
              onClick={() => {
                switchLocale(code);
              }}
              className={`w-full rounded px-3 py-2 text-left transition-colors ${
                code === locale
                  ? 'bg-[#2D1666] text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {LOCALE_LABELS.get(code) ?? code}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
